let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fV9R1")).then(() => parcelRequire('fI8tg'));